export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/96c97edbb58a791a1aa2b28a2cb82dfb.jpeg)',
        }}
      />

      {/* Solid Overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        <p className="text-orange-300 uppercase tracking-widest text-sm font-semibold mb-4 animate-fade-in">
          Welcome to
        </p>
        <h1 className="text-7xl lg:text-8xl font-extrabold mb-6 drop-shadow-xl">
          <span className="text-[#9B8EC4]">Kali</span>
          <span className="text-orange-400">Kare</span>
        </h1>
        <p className="text-white/85 text-xl leading-relaxed max-w-2xl mx-auto mb-10">
          Quality one-on-one homecare services tailored to your needs — helping you and your loved ones live comfortably at home.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#services"
            className="inline-block bg-[#5C4F8A] text-white px-10 py-4 rounded-lg hover:bg-[#4A3D72] transition-all duration-300 text-sm font-semibold whitespace-nowrap cursor-pointer shadow-xl hover:shadow-2xl"
          >
            Our Services
          </a>
          <a
            href="#contact"
            className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-lg transition-all duration-300 text-sm font-semibold whitespace-nowrap cursor-pointer shadow-xl hover:shadow-2xl"
          >
            Contact Us
          </a>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-white/10" />
    </section>
  );
}
